import React from "react";
import { Auth0Provider } from "@auth0/auth0-react";

// Use your existing values (or env vars)
const domain   = "login.investdecoded.com";
const clientId = "SHPqN1EtxMcPdOjfWBh21kb7Ow6RFgh2";
const audience = "https://master.d2axrpvyxe356p.amplifyapp.com/api";

function Auth0ProviderWrapper({ children }) {
  // We handle post-login redirect in AuthCallback.js via localStorage
  const onRedirectCallback = () => {};

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: window.location.origin + "/callback",
        audience,
        scope: "openid profile email",
        code_challenge_method: "S256",
      }}
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
}

export default Auth0ProviderWrapper;



